module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074c5_banner_800x600.b817a6d9.png";